export enum LoadRiskFlags {
  None = 0,
  MinAmountSubceeded = 1 << 0,   // 1
  MaxAmountExceeded = 1 << 1,    // 2
  InvalidCardStatus = 1 << 2,    // 4
  LimitExceeded = 1 << 3,        // 8
  FrequencyExceeded = 1 << 4,    // 16
  NoIdent = 1 << 5,              // 32
  NoPoa = 1 << 6,                // 64
  NoSof = 1 << 7,                // 128
  ThirdPartyLoad = 1 << 8,       // 256
  NeedsPreApproval = 1 << 9,      // 512
  WhiteListedThirdParty = 1 << 10,      // 1024
  GlobalWhiteListedThirdParty = 1 << 11,      // 2048
  ManualHold = 1 << 12,      // 4096


  RiskDeterminationError = 1 << 19 // 524288
}
